import "./App.css";
import { Route, Switch } from "react-router-dom";
import React, { lazy, Suspense, useEffect } from "react";
import { createApiInstance } from "src/api";
import Authenticated from "./screens/Authenticated";
import { useAuth } from "./contexts/AuthContext";
import { useUser } from "./contexts/UserContext";
import ActionQueue from "./screens/POC/ActionQueue";
import lazyWithRetry from "./lazyWithRetry";

const FromAuth = lazy(() => import("src/screens/FromAuth"));
const Unauthorized = lazyWithRetry(() => import("src/screens/Unauthorized"));
const Account = lazyWithRetry(() => import("src/screens/Account"));
const Dashboard = lazyWithRetry(() => import("src/screens/Dashboard"));
const AyalaApps = lazyWithRetry(() => import("src/screens/AyalaApps"));
const AssistAccountDetails = lazyWithRetry(
  () => import("src/screens/AssistAccountDetails")
);
const HomePage = lazyWithRetry(() => import("src/screens/Homepage"));
const Posts = lazyWithRetry(() => import("src/screens/Posts"));
const Assist = lazyWithRetry(() => import("src/screens/Assist"));
const DownloadLink = lazyWithRetry(() => import("src/screens/DownloadLink"));
const Faq = lazyWithRetry(() => import("src/screens/Faq"));
const NotAuthorized = lazyWithRetry(() => import("src/screens/NotAuthorized"));
const Events = lazyWithRetry(() => import("src/screens/Events"));
const AssistTermsAndCondition = lazyWithRetry(
  () => import("src/screens/ASSiSTTermsAndCondition")
);

import { Spinner } from "react-bootstrap";

const App: React.FC = () => {
  const auth = useAuth();
  const user = useUser();

  useEffect(() => {
    createApiInstance();
  }, []);

  useEffect(() => {
    if (auth?.isLoggedIn) {
      user?.initUserInfo?.();
    }
  }, [auth?.isLoggedIn]);

  // TODO: Remove this if Action Queue is fully integrated.
  if (process.env.REACT_APP_ACTION_QUEUE_POC === "true") {
    return <ActionQueue />;
  }

  return (
    <div className="App">
      <Suspense
        fallback={
          <Spinner
            style={{ position: "absolute", top: "50%", left: "50%" }}
            className="spinner"
            animation="border"
          />
        }
      >
        <Switch>
          <Route exact path="/">
            <FromAuth />
          </Route>
          <Route path="/unauthorized">
            <Unauthorized />
          </Route>
          <Route path="/dashboard">
            <Dashboard />
          </Route>
          <Route path="/events">
            <Events />
          </Route>
          <Route path="/home">
            <HomePage />
          </Route>
          <Route path="/ayalaapps">
            <AyalaApps />
          </Route>
          <Route path="/assist">
            <Assist />
          </Route>

          <Route path="/account">
            <Account />
          </Route>
          <Route path="/assist-account-details">
            <AssistAccountDetails />
          </Route>

          <Route path="/posts">
            <Posts />
          </Route>
          <Route path="/FAQs">
            <Faq />
          </Route>
          <Route path="/notauthorized">
            <NotAuthorized />
          </Route>

          <Route path="/download-link">
            <DownloadLink />
          </Route>

          <Route path="/AssistTerms">
            <AssistTermsAndCondition />
          </Route>

          <Authenticated />
        </Switch>
      </Suspense>
    </div>
  );
};

export default App;
